<template>
  <div class="user-bar">
    <!-- <a class="platform"
       style="background-color: none;"
       target="_blank"
       :href="`http://fleet.test.ninecosmos.cn/index?token=${token}`">监控平台</a> -->
    <div></div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link user-info">
        {{ userName }}
        <svg-icon icon-class="user"
                  class="img"></svg-icon>
        <!-- <arrow-down /> -->
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>
<script>
import { logout } from "../api/modules/addition";
import store from "@/store/index";

export default {
  name: "UserBar",
  data() {
    return {
      userName: "",
      token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTAwMDI2Miwicm9sZSI6MywiY29tcGFueUlkIjoxMDAwMDAzLCJkZXBhcnRtZW50SWQiOm51bGwsImlhdCI6MTY0ODUzODkxNywiZXhwIjozODUwMDEwOTE3fQ.ioKRtru-8VIJdkFCsR-Lcz54r_ERD3g3196KpoHNkKQ'
    };
  },
  methods: {
    logout() {
      store.dispatch("LOGOUT").then((res) => {
        this.$router.push("/login");
        store.dispatch("SET_MMSI", "");
      });
    },
  },
  mounted() {
    this.userName = sessionStorage.getItem("user-Name");
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-dropdown-menu {
  background-color: #375172 !important;
  border: 1px solid #375172 !important;
  color: white !important;
}
::v-deep .el-dropdown-menu__item {
  // color: #2a3e57;
  color: white !important;
}
::v-deep .el-dropdown-menu__item:not(.is-disabled):focus {
  background-color: #2a3e57 !important;
  color: white;
}
::v-deep .el-pooper {
  background-color: #375172 !important;
  border: 0px !important;
}
.platform {
  background-color: #375172;
  color: #63defe;
  padding: 1.5%;
  border-radius: 5%;
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;
}
@import "../styles/variables";
@media screen and (max-width: 1500px) {
  .user-bar {
    position: absolute;
    top: 65px;
    z-index: 2000;
    // top: 20px;
    width: 350px;
    right: 10px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .img {
      cursor: pointer;
      margin: 0 5px;
      height: 36px;
      width: 36px;
    }
    .user-info {
      display: flex;
      align-items: center;
      color: #dbdbdb;
    }
    .platform {
      font-size: 10px;
      // border-radius: 3px;
    }
  }
}
@media screen and (min-width: 1501px) {
  .user-bar {
    position: absolute;
    top: calc($header-height-1920 - 40px);
    z-index: 2000;
    // top: 20px;
    width: 24vw;
    right: 10px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .img {
      cursor: pointer;
      margin: 0 5px;
      height: 36px;
      width: 36px;
    }
    .user-info {
      display: flex;
      align-items: center;
      color: #dbdbdb;
    }
    .platform {
      font-size: 10px;
      // border-radius: 3px;
    }
  }
}

@media screen and (min-width: 1921px) {
  .user-bar {
    position: absolute;
    top: calc($header-height-2560 - 50px);
    z-index: 2000;
    right: 1vh;
    width: 24vw;
    height: 44px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .img {
      cursor: pointer;
      margin: 0 10px;
      height: 48px;
      width: 48px;
    }
    .user-info {
      display: flex;
      align-items: center;
      color: #dbdbdb;
      font-size: 24px;
    }
    .platform {
      font-size: 24px;
      // border-radius: 5px;
    }
  }
  :deep(.el-dropdown-menu__item) {
    font-size: 24px !important;
  }
}

@media screen and (min-width: 2561px) {
  .user-bar {
    position: absolute;
    // top: 40px;
    top: calc($header-height-4368 - 50px);
    z-index: 2000;
    right: 2vh;
    width: 20vw;
    height: 60px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .img {
      cursor: pointer;
      margin: 0 15px;
      height: 60px;
      width: 60px;
    }
    .user-info {
      display: flex;
      align-items: center;
      color: #dbdbdb;
      font-size: 30px;
    }
    .platform {
      font-size: 30px;
      // border-radius: 8px;
    }
  }
  :deep(.el-dropdown-menu__item) {
    font-size: 30px !important;
  }
}

@media screen and (min-width: 6700px) {
  .user-bar {
    position: absolute;
    // top: 60px;
    top: calc($header-height-6720 - 120px);
    z-index: 2000;
    right: 2vh;
    width: $sidebar-width;
    height: 100px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .img {
      cursor: pointer;
      margin: 0 20px;
      height: 100px;
      width: 100px;
    }
    .user-info {
      display: flex;
      align-items: center;
      color: #dbdbdb;
      font-size: 40px;
    }
    .platform {
      font-size: 40px;
      // border-radius: 10px;
    }
  }
  :deep(.el-dropdown-menu__item) {
    font-size: 40px !important;
  }
}
</style>
